// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U2zp","label":"styles_label__8mN0l"};